export default "__VITE_ASSET__BkmDTdtd__"